import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, videos } from '../../settings';
import { PersonProfile, VideoBg, DelayLink, HoveredImage } from '../../components';

import './Home.scss';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      mobile: window.innerWidth < 768 ? true : false,
    };

    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    // Actions.showMenu();
    // Actions.showHeader();
    // Actions.showFooter();
    Actions.headerHome();
    this.scrollTop();
  }

  componentDidUpdate() {}

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>{this.texts.title}</title>
        </Helmet>

        <div className="home" ref="home">
          <section className="welcome-area gradient-blue">
            {this.state.mobile == false && <VideoBg source={this.videos.home.banner_azul} />}
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <h1>
                      Relatório Anual
                      <br />
                      ANBIMA 2019
                    </h1>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section gray-section intro-area cards-home">
            <div className="container">
              <div className="row">
                <div className="col-8">
                  <Fade>
                    <div className="card card--blue">
                      <div className="card-title">
                        <h3 className="blue">Nosso ano</h3>
                        <p>
                          Confira as principais
                          <br />
                          <span className="blue">iniciativas para desenvolver o mercado de capitais</span>
                        </p>
                        <DelayLink
                          to="/estrategias/nosso-ano"
                          className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Saiba mais
                        </DelayLink>
                      </div>
                      <div className="nosso-ano-img">
                        <img src={images.home.nosso_ano} />
                      </div>
                    </div>
                  </Fade>
                </div>
                <div className="col-4">
                  <Fade>
                    <div className="card card--yellow card--mensagens">
                      <div className="card-title">
                        <h3 className="yellow">Mensagens</h3>
                        <p>Veja o que nossos líderes têm a dizer sobre 2019</p>
                      </div>
                      <div className="mensagens-home">
                        <DelayLink to="/mensagens/presidencia">
                          <img src={images.home.presidencia} />
                          <div className="btn-mensagens-home">
                            Carlos Ambrósio
                            <span>presidente</span>
                          </div>
                        </DelayLink>
                        <DelayLink to="/mensagens/superintendencia">
                          <img src={images.home.superintendencia} />
                          <div className="btn-mensagens-home">
                            Zeca Doherty
                            <span>superintendente-geral</span>
                          </div>
                        </DelayLink>
                        <img src={images.home.bg_mensagens} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section associados-area gradient-green">
            {this.state.mobile == false && <VideoBg source={this.videos.home.banner_verde} />}
            <div className="container">
              <div className="row">
                <div className="col-8"></div>
                <div className="col-4">
                  <Fade>
                    <p>
                      Entre gestoras, corretoras, distribuidoras, <br className="br_desk" />
                      bancos múltiplos, comerciais
                      <br className="br_desk" /> e de investimento, encerramos 2019
                    </p>
                    <br />
                  </Fade>
                  <span className="monster">
                    <Fade bottom cascade>
                      265
                    </Fade>
                  </span>
                  <br />
                  <span className="high">
                    <Fade bottom cascade>
                      associados
                    </Fade>
                  </span>

                  <Fade bottom>
                    <DelayLink
                      to="/associados"
                      className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                    >
                      Saiba mais
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="default-section gray-section intro-area blocks-area">
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title title--small">Quem somos</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Somos uma organização sem fins lucrativos. Reunimos instituições de diferentes portes e
                            segmentos, que retratam a pluralidade do mercado
                          </p>
                          <DelayLink
                            to="/quem-somos"
                            className="button button--aylen button--yellow button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Saiba mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--green">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title title--small">Diretoria</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Nossa Diretoria é formada por pessoas que ocupam o cargo de forma voluntária e que
                            representam a pluralidade de portes e segmentos das instituições do mercado
                          </p>
                          <DelayLink
                            to="/governanca-corporativa/diretoria"
                            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Saiba mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title title--small">Estratégia</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Todo ano, elaboramos um plano de ação para orientar nosso trabalho. Ele leva em conta as
                            tendências dos mercados brasileiro e internacional
                          </p>
                          <DelayLink
                            to="/plano-de-acao-2019"
                            className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Ver mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section
            className="default-section associados-area gradient-green linha-do-tempo"
            style={{
              backgroundImage: `url(${images.home.bg_linha_do_tempo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="container">
              <div className="card-title">
                <h3 className="white">Linha do tempo</h3>
                <p>
                  <span className="span-big white">
                    10 anos<br></br> de história
                  </span>
                </p>
                <p className="white">Conheça os grandes marcos da nossa jornada</p>
                <DelayLink
                  to="/linha-do-tempo"
                  className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                >
                  Ver mais
                </DelayLink>
              </div>
              <img className="linha-do-tempo-imagem" src={images.home.pessoa_linha_do_tempo} />
              <img className="linha-do-tempo-icon" src={images.home.icon_linha_do_tempo} />
            </div>
          </section>

          <section className="default-section gray-section intro-area cards-home cards-home-footer card-home-eventos">
            <div className="container">
              <div className="row">
                <div className="col-8">
                  <Fade>
                    <div className="card card--green card-half">
                      <div className="card-title">
                        <h3 className="green">Eventos</h3>
                        <p>
                          Mais de <span className="green span-big">4.700 pessoas</span> participaram de seminários,
                          debates, webinars e workshops sobre temas em alta no mercado e de interesse dos associados
                        </p>
                        <DelayLink
                          to="/eventos"
                          className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Saiba mais
                        </DelayLink>
                      </div>
                      <div>
                        <img src={images.home.bg_eventos} />
                      </div>
                    </div>
                  </Fade>
                </div>
                <div className="col-4">
                  <Fade>
                    <div className="card card--blue">
                      <div className="card-title">
                        <h3 className="blue">Pessoas</h3>
                        <p>
                          Nossos funcionários estão divididos em três escritórios:{' '}
                          <span className="blue">dois no Rio de Janeiro e um em São Paulo</span>
                        </p>
                        <DelayLink
                          to="/pessoas"
                          className="button button--aylen button--blue button--border-medium button--size-m button--round-l button--text-thick"
                        >
                          Ver mais
                        </DelayLink>
                      </div>
                      <div className="pessoas-rh-img">
                        <img src={images.home.pessoasRH_01} />
                        <img src={images.home.pessoasRH_02} />
                        <img src={images.home.pessoasRH_03} />
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { Home };
